import { css } from 'styled-components'

const background = {
    app: '#F6F9FC',
    appInverse: '#7A8997',
    positive: '#E1FFD4',
    negative: '#FEDED2',
    warning: '#FFF5CF',
}

const color = {
    // Palette
    primary: '#FF4785', // coral
    secondary: '#1EA7FD', // ocean
    tertiary: '#DDDDDD',

    orange: '#FC521F',
    gold: '#FFAE00',
    green: '#66BF3C',
    seafoam: '#37D5D3',
    purple: '#6F2CAC',
    lavender: '#E6E6FA',
    mauve: '#E0B0FF',
    thistle: '#E0B0FF',
    lightviolet: '#CF9FFF',
    periwinkle: '#CCCCFF',
    ultraviolet: '#2A0481',
    mediumcarmine: '#b24536',
    goldengatebridge: '#c4392f',
    deepcarminepink: '#ee312f',
    cadmiumpurple: '#ba1222',
    cultured: '#f7f6f3',
    lumber: '#ffe1cf',
    sweetbrown: '#b2352c',

    // Monochrome
    lightest: '#FFFFFF',
    lighter: '#F8F8F8',
    light: '#F3F3F3',
    mediumlight: '#EEEEEE',
    medium: '#DDDDDD',
    mediumdark: '#999999',
    dark: '#666666',
    darker: '#444444',
    darkest: '#000000',
    pampas: '#f7f6f3',
    raisinblack: '#212121',

    border: 'rgba(0,0,0,.1)',

    // Status
    positive: '#66BF3C',
    negative: '#FF4400',
    warning: '#E69D00',
}

const spacing = {
    padding: {
        small: 10,
        medium: 20,
        large: 30,
    },
    borderRadius: {
        small: 5,
        default: 10,
    },
}

const typography = {
    type: {
        primary: 'calluna, serif',
        secondary: 'bebas-neue-by-fontfabric,sans-serif',
    },
    weight: {
        regular: '400',
        bold: '700',
    },
    style: {
        normal: 'normal',
        italic: 'italic',
    },
    size: {
        root: '16px',
        s1: '0.75rem', // 12px
        s2: '0.875rem', // 14px
        s3: '1rem', // 16px
        m1: '1.25rem', // 20px
        m2: '1.5rem', // 24px
        m3: '1.75rem', // 28px
        l1: '2rem', // 32px
        l2: '2.5rem', // 40px
        l3: '3rem', // 48px
        l4: '3.25rem', // 48px
        l5: '4.5rem', // 72px
        l6: '5.25rem', // 84px
        code: '5.625rem', // 90px
        code1: '8.875rem', // 142px
        code2: '9.5rem', // 152px
        code3: '11.25rem', // 180px
    },
}

const pageMarginBreakpoint = 600
const pageMargin = 5.55555

const pageMargins = css`
    padding: 0 ${spacing.padding.medium}px;
    @media (min-width: ${pageMarginBreakpoint * 1}px) {
        margin: 0 ${pageMargin * 1}%;
    }
    @media (min-width: ${pageMarginBreakpoint * 2}px) {
        margin: 0 ${pageMargin * 2}%;
    }
    @media (min-width: ${pageMarginBreakpoint * 3}px) {
        margin: 0 ${pageMargin * 3}%;
    }
    @media (min-width: ${pageMarginBreakpoint * 4}px) {
        margin: 0 ${pageMargin * 4}%;
    }
`
const breakpoints = {
    xxs: '360px',
    xs: '375px',
    sm: '576px',
    md: '768px',
    lg: '1024px',
    xl: '1200px',
    xxl: '1400px',
    xxxl: '1900px',
    xxxxl: '2500px',
}

export {
    background,
    color,
    typography,
    breakpoints,
    pageMargin,
    pageMarginBreakpoint,
    pageMargins,
}
